import { render } from "./SidebarSection.vue?vue&type=template&id=08f265eb&scoped=true"
import script from "./SidebarSection.vue?vue&type=script&lang=js"
export * from "./SidebarSection.vue?vue&type=script&lang=js"

import "./SidebarSection.vue?vue&type=style&index=0&id=08f265eb&scoped=true&lang=css"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08f265eb"]])

export default __exports__